import { ASC } from 'Angular/constants/core.constants';
import { HypotheticalsSortColumn } from 'HypotheticalsApp/enums/hypotheticals-common.enum';
import * as i0 from "@angular/core";
/**
 * Base class for components that represent a saved hypothetical in a modal that shows saved folderable items
 * (meaning a modal that is a subclass of `FolderableSavedModalBaseDirective`).
 */
export class HypotheticalsSavedItemModalBaseDirective {
    constructor() {
        this.SAVED_ITEM_COLUMN_CONFIG = {
            [HypotheticalsSortColumn.NAME]: {
                label: 'name',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [HypotheticalsSortColumn.USER_MODIFY_DATE]: {
                label: 'date modified',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [HypotheticalsSortColumn.OWNER]: {
                label: 'owner',
                numCssCols: 2,
                defaultSortDirection: ASC,
            },
        };
        this.SAVED_ITEM_FILTER_DEFAULT = {
            owner: {
                me: true,
                shared_with_me: true,
            },
            page: 1,
            sortColumn: 'user_modify',
            sortDirection: ASC,
            name: '',
            includeEmptyFolders: false,
        };
        this.HypotheticalsSortColumn = HypotheticalsSortColumn;
    }
}
HypotheticalsSavedItemModalBaseDirective.ɵfac = function HypotheticalsSavedItemModalBaseDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HypotheticalsSavedItemModalBaseDirective)(); };
HypotheticalsSavedItemModalBaseDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: HypotheticalsSavedItemModalBaseDirective });
